module.exports = __webpack_public_path__ + "img/rue-saint-rome.170f9981.jpg";